import { createContext, useContext } from 'react';

// Create a context with default value
const AuthContext = createContext(undefined);

// Custom hook to use the auth context
function useAuthContext() {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  
  return context;
}

export { AuthContext, useAuthContext };